
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiFoodGoogle as ObiFoodGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-food-google.js';
 
 
 

 
 export const ObiFoodGoogle = createComponent({
   react: React,
   tagName: 'obi-food-google',
   elementClass: ObiFoodGoogleElement,
   events: {
     
   }
  });
 
 